import React, { useState, useEffect } from 'react';
import AuthUser from '../../../../../pageauth/AuthUser';
import PuenteApi from '../../../../../pageauth/PuenteApi';
import Mensaje from '../../../../../Mensaje';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Cargando from '../../../../../Cargando';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash, FaPlus, FaBook, FaChartLine, FaFile, FaMoneyBill, FaSave, FaGasPump } from 'react-icons/fa';

import CryptoJS from 'crypto-js';

export const RW_Combustibles_Tanques = () => {
    require('../../Remotework.css?v=1.1.0');
    const navigate = useNavigate();
    const { SetMensaje } = Mensaje();
    const { StartCargando, StopCargando } = Cargando();
    const { ObtenerEstaciones, ObtenerTanquesPorEndpoint, ObtenerCombustiblesPorEndpoint, ObtenerMangueras, RegistrarFuga, ObtenerFugas, EliminarFuga, AgregarTanque, ActualizarTanque, EliminarTanque, RegistrarMovimientoTanque } = PuenteApi();
    const { getModule, getModuleSector, getApodoSector } = AuthUser();

    const [estaciones, setEstaciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expanded, setExpanded] = useState({});
    const [tanquesPorEstacion, setTanquesPorEstacion] = useState({});
    const [selectedView, setSelectedView] = useState("tanques");

    // State for movements
    const [movimientos, setMovimientos] = useState({});

    // State for Tank CRUD
    const [nuevoTanque, setNuevoTanque] = useState({
        estacionId: "",
        numero: "",
        combustibleId: "",
        stockActual: "",
        capacidad: "",
        ubicacion: "",
        mangueras: []
    });
    const [editingTanqueId, setEditingTanqueId] = useState(null);
    const [combustiblesList, setCombustiblesList] = useState([]);
    const [manguerasDisponibles, setManguerasDisponibles] = useState([]);
    const [selectedMangueraId, setSelectedMangueraId] = useState("");
    const [showModal, setShowModal] = useState(false);

    const [fuga, setFuga] = useState({
        estacionId: "",
        aforadorId: "",
        cantidad: ""
    });
    const [mangueras, setMangueras] = useState([]);
    const [listaFugas, setListaFugas] = useState([]);
    const [mostrarFiltros, setMostrarFiltros] = useState(false);
    const [filtroFechas, setFiltroFechas] = useState({
        inicio: "",
        fin: ""
    });
    const [rangoMostrado, setRangoMostrado] = useState("Últimas 24 horas");

    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

    useEffect(() => {
        const estacionesGuardadas = localStorage.getItem("estaciones");

        if (estacionesGuardadas) {
            const bytes = CryptoJS.AES.decrypt(estacionesGuardadas, SECRET_KEY);
            const parsed = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            setEstaciones(parsed);
            obtenerTanquesDeTodas(parsed);
        } else {
            obtenerEstaciones();
        }
    }, []);

    const obtenerEstaciones = async () => {
        try {
            setLoading(true);
            const response = await ObtenerEstaciones();

            if (response) {
                setEstaciones(response);
                localStorage.setItem("estaciones", CryptoJS.AES.encrypt(JSON.stringify(response), SECRET_KEY).toString());
                await obtenerTanquesDeTodas(response);
            }
        } catch (error) {
            console.error("Error al obtener estaciones:", error);
        }
    };

    const obtenerTanquesDeTodas = async (listaEstaciones) => {
        const resultados = {};

        for (const estacion of listaEstaciones) {
            try {
                const response2 = await ObtenerTanquesPorEndpoint(estacion.endpoint);
                if (response2) {
                    resultados[estacion.id] = response2;
                } else {
                    resultados[estacion.id] = [];
                }
            } catch (error) {
                console.error("Error obteniendo tanques de", estacion.nombre, error);
                resultados[estacion.id] = [];
            }
        }
        setTanquesPorEstacion(resultados);
        setLoading(false);
    };

    const handleEstacionChangeForCRUD = async (e) => {
        const estacionId = e.target.value;
        setNuevoTanque(prev => ({ ...prev, estacionId: estacionId, combustibleId: "", mangueras: [] }));
        setCombustiblesList([]);
        setManguerasDisponibles([]);

        if (estacionId) {
            const estacionSeleccionada = estaciones.find(e => e.id == estacionId);
            if (estacionSeleccionada) {
                StartCargando("Cargando datos...");
                const combustibles = await ObtenerCombustiblesPorEndpoint(estacionSeleccionada.endpoint);
                const manguerasData = await ObtenerMangueras(estacionSeleccionada.endpoint);
                StopCargando();
                if (combustibles) {
                    setCombustiblesList(combustibles);
                }
                if (manguerasData) {
                    setManguerasDisponibles(manguerasData);
                }
            }
        }
    };

    const handleGuardarTanque = async (e) => {
        e.preventDefault();
        if (!nuevoTanque.estacionId || !nuevoTanque.numero || !nuevoTanque.combustibleId || !nuevoTanque.stockActual) {
            Swal.fire('Error', 'Estación, Número, Combustible y Stock Actual son obligatorios', 'error');
            return;
        }

        // Frontend Validation: Unique Number
        const tanquesEstacion = tanquesPorEstacion[nuevoTanque.estacionId] || [];
        const duplicate = tanquesEstacion.find(t => t.numero === nuevoTanque.numero && t.id !== editingTanqueId);
        if (duplicate) {
            Swal.fire('Error', 'Ya existe un tanque con este número en la estación seleccionada.', 'error');
            return;
        }

        const estacionSeleccionada = estaciones.find(e => e.id == nuevoTanque.estacionId);
        if (!estacionSeleccionada) return;

        StartCargando("Guardando tanque...");
        const data = {
            numero: nuevoTanque.numero,
            combustible_id: nuevoTanque.combustibleId,
            stockActual: nuevoTanque.stockActual,
            capacidad: nuevoTanque.capacidad,
            ubicacion: nuevoTanque.ubicacion,
            mangueras: nuevoTanque.mangueras.map(m => m.id) // Send only IDs
        };

        let success;
        if (editingTanqueId) {
            data.id = editingTanqueId;
            success = await ActualizarTanque(estacionSeleccionada.endpoint, data);
        } else {
            success = await AgregarTanque(estacionSeleccionada.endpoint, data);
        }

        if (success) {
            StopCargando();
            Swal.fire('Éxito', `Tanque ${editingTanqueId ? 'actualizado' : 'agregado'} correctamente`, 'success');
            setNuevoTanque({ estacionId: "", numero: "", combustibleId: "", stockActual: "", capacidad: "", ubicacion: "", mangueras: [] });
            setEditingTanqueId(null);
            setCombustiblesList([]);
            setManguerasDisponibles([]);
            setShowModal(false);
            obtenerTanquesDeTodas(estaciones);
        } else {
            StopCargando();
        }
    };

    const handleEditarTanque = async (tanque, estacionId) => {
        StartCargando("Cargando datos...");
        const estacionSeleccionada = estaciones.find(e => e.id == estacionId);
        let combustibles = [];
        let manguerasData = [];

        if (estacionSeleccionada) {
            combustibles = await ObtenerCombustiblesPorEndpoint(estacionSeleccionada.endpoint);
            manguerasData = await ObtenerMangueras(estacionSeleccionada.endpoint);
        }
        StopCargando();

        if (combustibles) setCombustiblesList(combustibles);
        if (manguerasData) setManguerasDisponibles(manguerasData);

        // Map stored IDs (or objects) to full hose objects from manguerasData
        const manguerasMapped = (tanque.mangueras || []).map(mItem => {
            const id = mItem.id || mItem; // Handle both object and ID
            return (manguerasData || []).find(md => md.id == id);
        }).filter(Boolean); // Remove nulls if hose not found

        setEditingTanqueId(tanque.id);
        setNuevoTanque({
            estacionId: estacionId,
            numero: tanque.numero,
            combustibleId: tanque.combustible_id,
            stockActual: tanque.stockActual,
            capacidad: tanque.capacidad,
            ubicacion: tanque.ubicacion,
            mangueras: manguerasMapped
        });
    };

    const handleCancelarEdicion = () => {
        setNuevoTanque({ estacionId: "", numero: "", combustibleId: "", stockActual: "", capacidad: "", ubicacion: "", mangueras: [] });
        setEditingTanqueId(null);
        setCombustiblesList([]);
        setManguerasDisponibles([]);
    };

    const handleAgregarManguera = () => {
        if (!selectedMangueraId) return;

        // 1. Check if already added to THIS tank
        const mangueraSeleccionada = manguerasDisponibles.find(m => m.id == selectedMangueraId);
        if (nuevoTanque.mangueras.find(m => m.id === mangueraSeleccionada.id)) {
            Swal.fire('Atención', 'Esta manguera ya está asignada a este tanque', 'warning');
            return;
        }

        // 2. Check if assigned to ANY OTHER tank in this station
        const tanquesEstacion = tanquesPorEstacion[nuevoTanque.estacionId] || [];
        for (const t of tanquesEstacion) {
            if (t.id === editingTanqueId) continue; // Skip current tank being edited

            // t.mangueras can be array of IDs or objects
            const isAssigned = (t.mangueras || []).some(m => {
                const id = m.id || m;
                return id == selectedMangueraId;
            });

            if (isAssigned) {
                Swal.fire('Error', `Esta manguera ya está asignada al tanque N° ${t.numero}`, 'error');
                return;
            }
        }

        if (mangueraSeleccionada) {
            setNuevoTanque(prev => ({
                ...prev,
                mangueras: [...prev.mangueras, mangueraSeleccionada]
            }));
            setSelectedMangueraId("");
        }
    };

    const handleEliminarManguera = (mangueraId) => {
        setNuevoTanque(prev => ({
            ...prev,
            mangueras: prev.mangueras.filter(m => m.id !== mangueraId)
        }));
    };

    const handleEliminarTanque = async (tanqueId, estacionId) => {
        const estacionSeleccionada = estaciones.find(e => e.id == estacionId);
        if (!estacionSeleccionada) return;

        Swal.fire({
            title: '¿Estás seguro?',
            text: "No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                StartCargando("Eliminando...");
                const success = await EliminarTanque(estacionSeleccionada.endpoint, { id: tanqueId });
                StopCargando();
                if (success) {
                    Swal.fire('Eliminado!', 'El tanque ha sido eliminado.', 'success');
                    obtenerTanquesDeTodas(estaciones);
                }
            }
        })
    };

    const handleToggle = (id) => {
        setExpanded(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const handleMovimientoChange = (estacionId, tanqueId, field, value) => {
        setMovimientos(prev => {
            const key = `${estacionId}-${tanqueId}`;
            const currentMov = prev[key] || { tipo: "-", cantidad: "" };

            if (field === 'tipo') {
                // If switching away from AJUSTE DE STOCK, and value is negative, reset it?
                // For now just keeping the value is fine, the input validation will catch it on next edit,
                // or we can sanitize it here. Let's sanitize.
                let newCantidad = currentMov.cantidad;
                if (value !== "AJUSTE DE STOCK" && parseFloat(newCantidad) < 0) {
                    newCantidad = Math.abs(parseFloat(newCantidad)).toString();
                }

                return {
                    ...prev,
                    [key]: { ...currentMov, tipo: value, cantidad: value === "-" ? "" : newCantidad }
                };
            } else if (field === 'cantidad') {
                // Validation: Only allow negative if tipo is "AJUSTE DE STOCK"
                if (currentMov.tipo !== "AJUSTE DE STOCK" && parseFloat(value) < 0) {
                    return prev; // Ignore negative input
                }
                return {
                    ...prev,
                    [key]: { ...currentMov, cantidad: value }
                };
            }
            return prev;
        });
    };

    const handleGuardarMovimiento = async (estacionId) => {
        const movimientosEstacion = Object.entries(movimientos)
            .filter(([key, val]) => key.startsWith(`${estacionId}-`) && val.tipo !== "-")
            .map(([key, val]) => {
                const [, tanqueId] = key.split('-');
                return { tanqueId, ...val };
            });

        if (movimientosEstacion.length === 0) {
            Swal.fire('Atención', 'No hay movimientos seleccionados para guardar.', 'warning');
            return;
        }

        const estacionSeleccionada = estaciones.find(e => e.id == estacionId);
        if (!estacionSeleccionada) return;

        StartCargando("Guardando movimientos...");
        let errors = 0;
        for (const mov of movimientosEstacion) {
            const data = {
                tanque_id: mov.tanqueId,
                tipo: mov.tipo,
                cantidad: mov.cantidad,
                usuario: JSON.parse(localStorage.getItem("user")).name + " " + JSON.parse(localStorage.getItem("user")).apellido
            };
            const success = await RegistrarMovimientoTanque(estacionSeleccionada.endpoint, data);
            if (!success) errors++;
        }
        StopCargando();

        if (errors === 0) {
            Swal.fire('Éxito', 'Todos los movimientos se guardaron correctamente', 'success');
        } else if (errors < movimientosEstacion.length) {
            Swal.fire('Advertencia', `Se guardaron algunos movimientos, pero hubo ${errors} errores.`, 'warning');
        } else {
            // Errors are already shown by PuenteApi
        }

        // Reset movements for this station and refresh data
        setMovimientos(prev => {
            const newState = { ...prev };
            Object.keys(newState).forEach(key => {
                if (key.startsWith(`${estacionId}-`)) delete newState[key];
            });
            return newState;
        });
        obtenerTanquesDeTodas(estaciones);
    };

    // Fuga logic remains mostly the same
    const handleEstacionFugaChange = async (e) => {
        const estacionId = e.target.value;
        setFuga({ ...fuga, estacionId: estacionId, aforadorId: "" });
        setMangueras([]);
        setListaFugas([]);
        setRangoMostrado("Últimas 24 horas");

        if (estacionId) {
            const estacionSeleccionada = estaciones.find(e => e.id == estacionId);
            if (estacionSeleccionada) {
                StartCargando("Cargando datos...");
                const manguerasData = await ObtenerMangueras(estacionSeleccionada.endpoint);
                const fugasData = await ObtenerFugas(estacionSeleccionada.endpoint);
                StopCargando();
                if (manguerasData) {
                    setMangueras(manguerasData);
                }
                if (fugasData) {
                    setListaFugas(fugasData);
                }
            }
        }
    };

    const handleActualizarFugas = async (estacionId, filtros = {}) => {
        const estacionSeleccionada = estaciones.find(e => e.id == estacionId);
        if (estacionSeleccionada) {
            const fugasData = await ObtenerFugas(estacionSeleccionada.endpoint, filtros);
            if (fugasData) {
                setListaFugas(fugasData);
            }
        }
    }

    const handleFiltrarFugas = () => {
        if (filtroFechas.inicio && filtroFechas.fin) {
            handleActualizarFugas(fuga.estacionId, {
                fecha_inicio: filtroFechas.inicio,
                fecha_fin: filtroFechas.fin
            });
            setRangoMostrado(`Desde ${new Date(filtroFechas.inicio).toLocaleString()} hasta ${new Date(filtroFechas.fin).toLocaleString()}`);
        } else {
            Swal.fire('Atención', 'Debe seleccionar fecha de inicio y fin', 'warning');
        }
    };

    const handleRegistrarFuga = async (e) => {
        e.preventDefault();
        if (!fuga.estacionId || !fuga.aforadorId || !fuga.cantidad) {
            Swal.fire('Error', 'Todos los campos son obligatorios', 'error');
            return;
        }

        const estacionSeleccionada = estaciones.find(e => e.id == fuga.estacionId);
        if (!estacionSeleccionada) return;

        StartCargando("Registrando fuga...");
        const data = {
            aforador_id: fuga.aforadorId,
            cantidad: fuga.cantidad
        };

        const success = await RegistrarFuga(estacionSeleccionada.endpoint, data);

        if (success) {
            StopCargando();
            Swal.fire('Éxito', 'Fuga registrada correctamente', 'success');
            setFuga({ ...fuga, aforadorId: "", cantidad: "" });
            handleActualizarFugas(fuga.estacionId);
        } else {
            StopCargando();
        }
    };

    const handleEliminarFuga = async (id) => {
        const estacionSeleccionada = estaciones.find(e => e.id == fuga.estacionId);
        if (!estacionSeleccionada) return;

        Swal.fire({
            title: '¿Estás seguro?',
            text: "No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                StartCargando("Eliminando...");
                const success = await EliminarFuga(estacionSeleccionada.endpoint, { id: id });
                StopCargando();
                if (success) {
                    Swal.fire(
                        'Eliminado!',
                        'El registro ha sido eliminado.',
                        'success'
                    )
                    const filtros = {};
                    if (filtroFechas.inicio && filtroFechas.fin) {
                        filtros.fecha_inicio = filtroFechas.inicio;
                        filtros.fecha_fin = filtroFechas.fin;
                    }
                    handleActualizarFugas(fuga.estacionId, filtros);
                }
            }
        })
    };

    return (
        <div>
            <div className="container-fluid py-4">

                {/* ======================== BOTONES SUPERIORES ======================== */}
                <div className="mb-3">
                    <button
                        className={`btn mb-3 ${selectedView === "tanques" ? "btn-success" : "btn-primary"}`}
                        onClick={() => setSelectedView("tanques")}
                    >
                        <FaGasPump /> Tanques
                    </button>

                    <button
                        className={`btn mb-3 ms-2 ${selectedView === "fuga" ? "btn-success" : "btn-primary"}`}
                        onClick={() => setSelectedView("fuga")}
                    >
                        <FaBook /> Agregar/Modificar
                    </button>

                    <button
                        className={`btn mb-3 ms-2 ${selectedView === "estadisticas" ? "btn-success" : "btn-primary"}`}
                        onClick={() => setSelectedView("estadisticas")}
                    >
                        <FaChartLine /> Estadísticas
                    </button>

                    <button
                        className={`btn mb-3 ms-2 ${selectedView === "reportes" ? "btn-success" : "btn-primary"}`}
                        onClick={() => setSelectedView("reportes")}
                    >
                        <FaFile /> Reportes
                    </button>
                </div>

                {/* TANQUES */}
                {selectedView === "tanques" && (
                    <>
                        {loading ? "Cargando..." : (

                            estaciones.map((estacion) => (
                                <div key={estacion.id} className="mb-3">
                                    <div
                                        onClick={() => handleToggle(estacion.id)}
                                        className="d-flex justify-content-between align-items-center p-3 border rounded cursor-pointer"
                                        style={{
                                            backgroundColor: '#f5f5f5',
                                            borderColor: '#ddd',
                                            fontWeight: 'bold',
                                            fontSize: '16px',
                                        }}
                                    >
                                        <span>{estacion.nombre}</span>
                                        <span>{expanded[estacion.id] ? '▲' : '▼'}</span>
                                    </div>

                                    {expanded[estacion.id] && (
                                        <div className="p-3 border mt-2" style={{ backgroundColor: '#fafafa' }}>
                                            {tanquesPorEstacion[estacion.id] ? (
                                                tanquesPorEstacion[estacion.id].length > 0 ? (
                                                    <>
                                                        <Table bordered hover responsive className="table-custom">
                                                            <thead>
                                                                <tr className="table-light">
                                                                    <th>N° de tanque</th>
                                                                    <th>Combustible</th>
                                                                    <th>Stock actual</th>
                                                                    <th>Aplicar movimiento</th>
                                                                    <th>Cantidad movimiento</th>
                                                                    <th>Stock final</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {tanquesPorEstacion[estacion.id].map(tanque => {
                                                                    const movKey = `${estacion.id}-${tanque.id}`;
                                                                    const movimiento = movimientos[movKey] || { tipo: "-", cantidad: "" };

                                                                    let stockFinal = parseFloat(tanque.stockActual) || 0;
                                                                    const cantidad = parseFloat(movimiento.cantidad) || 0;

                                                                    if (movimiento.tipo !== "-" && cantidad !== 0) {
                                                                        switch (movimiento.tipo) {
                                                                            case "DESCARGA EN TANQUES":
                                                                                stockFinal += Math.abs(cantidad);
                                                                                break;
                                                                            case "AJUSTE DE STOCK":
                                                                                stockFinal += cantidad; // Can be negative
                                                                                break;
                                                                            case "PURGA":
                                                                            case "PRUEBA SIN RETONRO":
                                                                            case "SALIDA":
                                                                                stockFinal -= Math.abs(cantidad);
                                                                                break;
                                                                            default:
                                                                                break;
                                                                        }
                                                                    }

                                                                    return (
                                                                        <tr key={tanque.id}>
                                                                            <td>{tanque.numero}</td>
                                                                            <td>{tanque.combustible}</td>
                                                                            <td>
                                                                                <Form.Control
                                                                                    type="number"
                                                                                    value={tanque.stockActual}
                                                                                    readOnly
                                                                                    style={{ backgroundColor: '#e9ecef' }}
                                                                                />
                                                                            </td>
                                                                            <td>
                                                                                <Form.Select
                                                                                    value={movimiento.tipo}
                                                                                    onChange={(e) => handleMovimientoChange(estacion.id, tanque.id, 'tipo', e.target.value)}
                                                                                >
                                                                                    <option value="-">-</option>
                                                                                    <option value="DESCARGA EN TANQUES">DESCARGA EN TANQUES</option>
                                                                                    <option value="PURGA">PURGA</option>
                                                                                    <option value="PRUEBA SIN RETONRO">PRUEBA SIN RETONRO</option>
                                                                                    <option value="AJUSTE DE STOCK">AJUSTE DE STOCK</option>
                                                                                    <option value="SALIDA">SALIDA</option>
                                                                                </Form.Select>
                                                                            </td>
                                                                            <td>
                                                                                <Form.Control
                                                                                    type="number"
                                                                                    value={movimiento.cantidad}
                                                                                    onChange={(e) => handleMovimientoChange(estacion.id, tanque.id, 'cantidad', e.target.value)}
                                                                                    disabled={movimiento.tipo === "-"}
                                                                                    min={movimiento.tipo === "AJUSTE DE STOCK" ? undefined : "0"}
                                                                                    placeholder="0.00"
                                                                                />
                                                                            </td>
                                                                            <td>
                                                                                <Form.Control
                                                                                    type="number"
                                                                                    value={stockFinal}
                                                                                    readOnly
                                                                                    style={{ backgroundColor: '#e9ecef', fontWeight: 'bold' }}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </Table>
                                                        <div className="d-flex justify-content-end mt-3">
                                                            <Button
                                                                variant="primary"
                                                                onClick={() => handleGuardarMovimiento(estacion.id)}
                                                            >
                                                                <FaSave /> Guardar movimiento
                                                            </Button>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <p>No se encontraron tanques.</p>
                                                )
                                            ) : (
                                                <p>Cargando tanques...</p>
                                            )}
                                        </div>
                                    )}
                                </div>
                            ))
                        )}
                    </>
                )}

                {/* AGREGAR / MODIFICAR TANQUES */}
                {selectedView === "fuga" && (
                    <>
                        <div className="d-flex justify-content-end mb-3">
                            <Button variant="primary" onClick={() => {
                                setEditingTanqueId(null);
                                setNuevoTanque({ estacionId: "", numero: "", combustibleId: "", stockActual: "", capacidad: "", ubicacion: "", mangueras: [] });
                                setCombustiblesList([]);
                                setManguerasDisponibles([]);
                                setShowModal(true);
                            }}>
                                <FaPlus /> Agregar Nuevo Tanque
                            </Button>
                        </div>

                        {estaciones.map((estacion) => (
                            <div key={estacion.id} className="mb-3">
                                <div
                                    onClick={() => handleToggle(estacion.id)}
                                    className="d-flex justify-content-between align-items-center p-3 border rounded cursor-pointer"
                                    style={{
                                        backgroundColor: '#f5f5f5',
                                        borderColor: '#ddd',
                                        fontWeight: 'bold',
                                        fontSize: '16px',
                                    }}
                                >
                                    <span>{estacion.nombre}</span>
                                    <span>{expanded[estacion.id] ? '▲' : '▼'}</span>
                                </div>

                                {expanded[estacion.id] && (
                                    <div className="p-3 border mt-2" style={{ backgroundColor: '#fafafa' }}>
                                        <div className="d-flex justify-content-end mb-2">
                                            <Button variant="success" size="sm" onClick={() => {
                                                setEditingTanqueId(null);
                                                setNuevoTanque({ estacionId: estacion.id, numero: "", combustibleId: "", stockActual: "", capacidad: "", ubicacion: "", mangueras: [] });
                                                handleEstacionChangeForCRUD({ target: { value: estacion.id } }); // Pre-load data
                                                setShowModal(true);
                                            }}>
                                                <FaPlus /> Agregar Tanque
                                            </Button>
                                        </div>
                                        {tanquesPorEstacion[estacion.id] && tanquesPorEstacion[estacion.id].length > 0 ? (
                                            <Table bordered hover responsive className="table-custom">
                                                <thead>
                                                    <tr className="table-light">
                                                        <th>N°</th>
                                                        <th>Combustible</th>
                                                        <th>Stock Actual</th>
                                                        <th>Capacidad</th>
                                                        <th>Ubicación</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {tanquesPorEstacion[estacion.id].map((tanque) => (
                                                        <tr key={tanque.id}>
                                                            <td>{tanque.numero}</td>
                                                            <td>{tanque.combustible}</td>
                                                            <td>{tanque.stockActual}</td>
                                                            <td>{tanque.capacidad}</td>
                                                            <td>{tanque.ubicacion}</td>
                                                            <td>
                                                                <Button
                                                                    variant="warning"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    onClick={() => {
                                                                        handleEditarTanque(tanque, estacion.id);
                                                                        setShowModal(true);
                                                                    }}
                                                                >
                                                                    <FaPencilAlt />
                                                                </Button>
                                                                <Button
                                                                    variant="danger"
                                                                    size="sm"
                                                                    onClick={() => handleEliminarTanque(tanque.id, estacion.id)}
                                                                >
                                                                    <FaTrash />
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        ) : (
                                            <p className="text-muted">No hay tanques registrados.</p>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}

                        {/* Modal for Add/Edit */}
                        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                            <Modal.Header closeButton>
                                <Modal.Title>{editingTanqueId ? "Modificar Tanque" : "Agregar Nuevo Tanque"}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form onSubmit={(e) => { handleGuardarTanque(e); setShowModal(false); }}>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <Form.Label>Estación</Form.Label>
                                            <Form.Select
                                                value={nuevoTanque.estacionId}
                                                onChange={handleEstacionChangeForCRUD}
                                                disabled={!!editingTanqueId}
                                                required
                                            >
                                                <option value="">Seleccione una estación</option>
                                                {estaciones.map((estacion) => (
                                                    <option key={estacion.id} value={estacion.id}>{estacion.nombre}</option>
                                                ))}
                                            </Form.Select>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <Form.Label>N° de Tanque</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={nuevoTanque.numero}
                                                onChange={(e) => setNuevoTanque({ ...nuevoTanque, numero: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <Form.Label>Combustible</Form.Label>
                                            <Form.Select
                                                value={nuevoTanque.combustibleId}
                                                onChange={(e) => setNuevoTanque({ ...nuevoTanque, combustibleId: e.target.value })}
                                                required
                                                disabled={!nuevoTanque.estacionId}
                                            >
                                                <option value="">Seleccione combustible</option>
                                                {combustiblesList.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                                ))}
                                            </Form.Select>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <Form.Label>Stock Actual</Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={nuevoTanque.stockActual}
                                                onChange={(e) => setNuevoTanque({ ...nuevoTanque, stockActual: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <Form.Label>Capacidad</Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={nuevoTanque.capacidad}
                                                onChange={(e) => setNuevoTanque({ ...nuevoTanque, capacidad: e.target.value })}
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <Form.Label>Ubicación</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={nuevoTanque.ubicacion}
                                                onChange={(e) => setNuevoTanque({ ...nuevoTanque, ubicacion: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    {/* Asignación de Mangueras */}
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <h6 className="text-secondary border-bottom pb-2">Asignar Mangueras</h6>
                                        </div>
                                        <div className="col-md-8">
                                            <Form.Select
                                                value={selectedMangueraId}
                                                onChange={(e) => setSelectedMangueraId(e.target.value)}
                                                disabled={!nuevoTanque.combustibleId}
                                            >
                                                <option value="">Seleccione una manguera</option>
                                                {manguerasDisponibles
                                                    .filter(m => {
                                                        const selectedFuel = combustiblesList.find(c => c.id == nuevoTanque.combustibleId);
                                                        return selectedFuel && m.tipocombustible === selectedFuel.nombre;
                                                    })
                                                    .map(m => (
                                                        <option key={m.id} value={m.id}>
                                                            Manguera {m.manguera} - {m.tipocombustible} (Aforador: {m.aforador})
                                                        </option>
                                                    ))}
                                            </Form.Select>
                                        </div>
                                        <div className="col-md-4">
                                            <Button
                                                variant="outline-primary"
                                                onClick={handleAgregarManguera}
                                                disabled={!selectedMangueraId}
                                                className="w-100"
                                            >
                                                <FaPlus /> Agregar Manguera
                                            </Button>
                                        </div>
                                    </div>

                                    {nuevoTanque.mangueras.length > 0 && (
                                        <div className="row mb-3">
                                            <div className="col-12">
                                                <Table size="sm" bordered>
                                                    <thead>
                                                        <tr>
                                                            <th>Manguera</th>
                                                            <th>Combustible</th>
                                                            <th>Aforador</th>
                                                            <th>Acción</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {nuevoTanque.mangueras.map((m, idx) => (
                                                            <tr key={idx}>
                                                                <td>{m.manguera}</td>
                                                                <td>{m.tipocombustible}</td>
                                                                <td>{m.aforador}</td>
                                                                <td>
                                                                    <Button
                                                                        variant="danger"
                                                                        size="sm"
                                                                        onClick={() => handleEliminarManguera(m.id)}
                                                                    >
                                                                        <FaTrash />
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </div>
                                    )}

                                    <div className="d-flex justify-content-end">
                                        <Button variant="secondary" className="me-2" onClick={() => setShowModal(false)}>
                                            Cancelar
                                        </Button>
                                        <Button variant="success" type="submit">
                                            {editingTanqueId ? "Actualizar" : "Guardar"}
                                        </Button>
                                    </div>
                                </Form>
                            </Modal.Body>
                        </Modal>
                    </>
                )}

                {/* ESTADISTICAS */}
                {selectedView === "estadisticas" && (
                    <div className="alert alert-info">
                        Sección de Estadísticas en construcción...
                    </div>
                )}

                {/* REPORTES */}
                {selectedView === "reportes" && (
                    <div className="card p-4 shadow-sm" style={{ margin: '0 auto' }}>
                        <h3 className="text-primary">Reportes</h3>
                        <center><p>Proximamente...</p></center>
                    </div>
                )}

            </div>
        </div>
    );
};

